import { render, staticRenderFns } from "./cat-sort.vue?vue&type=template&id=9a176f06&"
import script from "./cat-sort.vue?vue&type=script&lang=js&"
export * from "./cat-sort.vue?vue&type=script&lang=js&"
import style0 from "./cat-sort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/www/xmg-cms-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9a176f06', component.options)
    } else {
      api.reload('9a176f06', component.options)
    }
    module.hot.accept("./cat-sort.vue?vue&type=template&id=9a176f06&", function () {
      api.rerender('9a176f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cats/cat-sort.vue"
export default component.exports